import React from 'react';
import {useTable} from 'react-table';
import {FormattedMessage} from 'react-intl';
import {CommonTable} from '../../_common/components/CommonTable/CommonTable';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import styles from './styles.module.scss';

export function TableHiddenLines() {
  const {columns, dataHiddenReceiptLines} = useTransfersByAgentContext();

  return (
    <div>
      <h3>
        <FormattedMessage
          id="transfersByAgent-hidden-lines"
          defaultMessage={`Hidden lines (${dataHiddenReceiptLines.length})`}
          values={{count: dataHiddenReceiptLines.length}}
        />
      </h3>
      <CommonTable
        tableProps={useTable({columns, data: dataHiddenReceiptLines})}
        customContainerStyles={'w-100'}
        customHeaderStyles={styles.tableHeader}
        customContainerID={'bulkActionsTableContainer'}
        customTableStyles={'transfers-hidden-lines'}
        customTableHeadColor={'transfers-tableHead'}
      />
    </div>
  )
}

export default TableHiddenLines;
